if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = false; //this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const accessoriesUpsells = this.closest('product-info')?.querySelectorAll('input[name="upsell_accesories"]:checked')
      const buttonSpan = this.submitButton.querySelector('span');
      const buttonSpanText = buttonSpan.innerHTML;
      const id = this.form.querySelector('[name=id]').value;
      const items = []
      let quantity = 1;

      if (document.querySelector('[data-cart-quantity]')) {
        quantity = parseInt(document.querySelector('[data-cart-quantity]').value);
      }

      // For gift card
      let properties = {};
      const giftCardForm = this.form.querySelector('recipient-form')

      if (giftCardForm) {
        const isGiftChecked = giftCardForm.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]').checked;
        const giftRecipientEmail = giftCardForm.querySelector('[name="properties[Recipient email]"]').value

        if (isGiftChecked && giftRecipientEmail !== '') {
          const giftCardFormProperties = giftCardForm.querySelectorAll('[name*="properties"]')
          giftCardFormProperties.forEach((property) => {
            if (!property.disabled && property.value !== '') {
              let propertyName = property.getAttribute('name').replace('properties[', '').replace(']', '');
              properties[propertyName] = property.value;
            }
          })
        }
      }

      // if upsells selected push to items array
      if(accessoriesUpsells && accessoriesUpsells.length > 0) {
        accessoriesUpsells.forEach((upsell) => {
          items.push({
            id: upsell.value,
            quantity: 1
          })
        })
      }

      // pushed main product to items array
      items.push({
        id,
        quantity: quantity || 0,
        properties
      })

      await window.theme.addToCart(items)
        .then((result) => {
          if (result.error) {
            this.handleErrorMessage(result.error);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            soldOutMessage.textContent = result.error;
            this.error = true;
            return
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            quickAddModal.hide(true);
          }
        }).finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

          if(!buttonSpan.closest('.product-card-wrapper')) {
            buttonSpan.innerHTML = 'Added!';
            setTimeout(function(){
              buttonSpan.innerHTML = buttonSpanText;
            }, 3000);
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    connectedCallback() {
      const restrictedMetaField = this.dataset.restricted // Fetch metafield value
      
      // Get the value of the 'access' query parameter
      const restricted = getCookie('restricted');
      const addToCartButton = this.querySelector('.product-form__submit-button');
      const notifyMeButton = this.querySelector('.product__notify-button');

      if(this.closest('.product-card-wrapper')) {
        // Hide Add to Cart button and show Sold Out badge based on conditions on product cards
        if (restrictedMetaField === 'true') {
          if (restricted !== 'disabled') {
            this.querySelector('.quick-add__submit').remove()

            // show sold out badge
            const parentWrapper = this.closest('.product-card-wrapper');
            parentWrapper.querySelector('.badge--sold-out').classList.remove('hidden');
          }
        }
      } else {
        // Show Add to Cart button or Sold Out/Notify Me based on conditions on PDP
        if (restrictedMetaField === 'true') {
          if (restricted === 'disabled') {
            // Show Add to Cart button
            if (addToCartButton) {
              addToCartButton.classList.remove('hidden'); // Show the button
            }
            
            if (notifyMeButton) {
              notifyMeButton.classList.add('hidden'); // Hide the "Notify Me" button
            }
          } else {
            // Show Sold Out/Notify Me
            if (addToCartButton) {
              addToCartButton.classList.add('hidden'); // Hide the Add to Cart button
            }

            if (notifyMeButton) {
              notifyMeButton.classList.remove('hidden'); // Show the "Notify Me" button
            }
          }
        } else {
          // If the product is not restricted and available, show the regular Add to Cart button
          if (addToCartButton.disabled) {
            if (addToCartButton) {
              addToCartButton.classList.add('hidden'); // Hides the Add to Cart button if product is not available
            }

            if (notifyMeButton) {
              notifyMeButton.classList.remove('hidden'); // Shows the Notify me button if product is not available
            }
          } else {
            if (addToCartButton) {
              addToCartButton.classList.remove('hidden'); // Show the Add to Cart button
            }
  
            if (notifyMeButton) {
              notifyMeButton.classList.add('hidden'); // Hide Notify Me
            }
          }
          
        }
      }
    }
  });
}
